var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenCartonBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 53.315 53.315",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.752,13.507c-0.762-0.05-0.981,0.386-0.49,0.972l8.586,10.207c0.492,0.586,1.508,1.039,2.271,1.014l11.304-0.085 L9.133,14.026L0.752,13.507z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.643,12.065L34.729,6.569c-0.729-0.224-1.756,0.038-2.291,0.583l-3.158,3.209c-0.082,0.083-0.143,0.171-0.193,0.258 l-3.404-4.195c-0.266-0.715-1.096-1.222-1.854-1.13L7.915,7.21C7.157,7.302,6.826,7.926,7.174,8.603l1.96,5.424l20.238-2.235 c0.062,0.042,0.128,0.079,0.204,0.112l15.686,6.892l-22.839,6.819l5.589,8.399c0.403,0.647,1.319,0.985,2.045,0.748l21.643-7.01 c0.726-0.233,0.894-0.878,0.375-1.438l-4.708-7.308c0.247-0.098,0.475-0.237,0.649-0.416L53,13.461 C53.534,12.912,53.373,12.289,52.643,12.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.363,36.774c-0.725,0.237-1.631-0.1-2.025-0.755l-5.247-8.72h-11.92v3.864c0,0.553,0.287,1.344,0.641,1.768 l12.193,14.618c0.354,0.424,1.056,0.603,1.569,0.396l18.873-7.551c0.513-0.205,0.979-0.815,1.041-1.364l0.839-7.471L29.363,36.774z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCartonBox);
export default __webpack_public_path__ + "static/media/open-carton-box.bd2cd8c3.svg";
export { ForwardRef as ReactComponent };